import {API_ORIGIN} from "./config";
import type {Capabilities, ProblemDetail, RunResponse, Session, CaseInput} from "./types";

export class ApiProblem extends Error {
  readonly status: number;
  readonly code: string;
  constructor(problem: ProblemDetail, status: number) {
    super(problem.detail ?? problem.title ?? `Request failed (${status})`);
    this.name = "ApiProblem";
    this.status = status;
    this.code = problem.code ?? "PWSO_CLIENT_REQUEST";
  }
}

async function decode<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let problem: ProblemDetail = {};
    try {problem = await response.json() as ProblemDetail;} catch {problem = {detail: response.statusText};}
    throw new ApiProblem(problem, response.status);
  }
  return await response.json() as T;
}

function request(path: string, init?: RequestInit) {
  return fetch(`${API_ORIGIN}${path}`, {...init, credentials: "include", headers: {"Content-Type": "application/json", ...init?.headers}});
}

export async function getCapabilities() {return decode<Capabilities>(await request("/api/v1/capabilities", {method: "GET"}));}
export async function getSession() {return decode<Session>(await request("/api/v1/auth/session", {method: "GET"}));}

export async function login(username: string, password: string) {
  const challenge = await decode<{csrf_token: string}>(await request("/api/v1/auth/csrf", {method: "GET"}));
  return decode<Session>(await request("/api/v1/auth/login", {method: "POST", headers: {"X-CSRF-Token": challenge.csrf_token}, body: JSON.stringify({username, password})}));
}

export async function logout(session: Session) {
  return decode<{authenticated: false}>(await request("/api/v1/auth/logout", {method: "POST", headers: {"X-CSRF-Token": session.csrf_token}, body: "{}"}));
}

export async function runCases(cases: CaseInput[], session: Session) {
  return decode<RunResponse>(await request("/api/v1/runs", {method: "POST", headers: {"X-CSRF-Token": session.csrf_token}, body: JSON.stringify({schema_version: "1.0.0", cases})}));
}
